import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import Auth from '@aws-amplify/auth'
import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

import config from './config'

export const baseQuery = fetchBaseQuery({
  baseUrl: config.api.endpoint,
  prepareHeaders: async headers => {
    try {
      const session = await Auth.currentSession()
      const token = session.getIdToken().getJwtToken()
      headers.set('authorization', `Bearer ${token}`)
    } catch (err) {}
    return headers
  },
})

const extendedBaseQuery = baseUrl => async (args, api, extraOptions) => {
  const transformKeys = ['params', 'body']
  const transformedArgs =
    typeof args === 'object'
      ? {
          ...args,
          ...transformKeys.reduce((acc, key) => {
            const toTransform = args[key]
            if (toTransform) {
              acc[key] = snakecaseKeys(toTransform, {
                deep: true,
                exclude: ['invoice__isnull'],
              })
            }
            return acc
          }, {}),
        }
      : args

  try {
    const result = await baseQuery(transformedArgs, api, extraOptions)
    const transformed = camelcaseKeys(result, { deep: true })
    return transformed
  } catch (error) {
    if (error.response) {
      error.response.data = camelcaseKeys(error.response.data, { deep: true })
    }
    throw error
  }
}

const apiRTKQ = createApi({
  reducerPath: 'apiRTKQ',
  baseQuery: extendedBaseQuery(config.api.endpoint),
  tagTypes: ['Buyers', 'Invoices', 'LineItems', 'Orders'],
  endpoints: () => ({}),
})

const apiRTKQV2 = createApi({
  reducerPath: 'apiRTKQ',
  baseQuery: extendedBaseQuery(config.api.endpointV2),
  tagTypes: ['Buyers', 'Invoices', 'LineItems', 'Orders'],
  endpoints: () => ({}),
})

export { apiRTKQV2 }
export default apiRTKQ
